import Image from "next/image";
import Link from "next/link";
import { useDispatch } from "react-redux";
import { setCurrentProduct } from "@/store/feature/productSlice";
import { useRef } from "react";

export function TopSellingProductCard({ product }) {
  const addToCardRef = useRef();
  const dispatch = useDispatch();

  const {
    product_variation_promo_price,
    product_variation_price,
    slug,
    product_name,
    product_variation_image,
  } = product;

  const handleAddToCart = () => {
    addToCardRef.current.click();
    dispatch(setCurrentProduct(product));
  };

  return (
    <div className="flex gap-4">
      <Link href={`/product/${slug}`}>
        <div className="min-w-[88px] min-h-[88px] bg-grayD9 flex items-center justify-center rounded-[4px]">
          <Image
            src={product_variation_image}
            alt={product_name}
            height={54}
            width={64}
          />
        </div>
      </Link>

      <div className="flex flex-col gap-4 w-full">
        <Link href={`/product/${slug}`}>
          <p className="text-grayD2  line-clamp-2">{product_name}</p>
        </Link>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <p className="text-grayD2 font-semibold">
              ৳
              {product_variation_promo_price > 0
                ? product_variation_promo_price
                : product_variation_price}
            </p>
            {product_variation_promo_price > 0 && (
              <p className="text-grayD4 line-through">
                ৳{product_variation_price}
              </p>
            )}
          </div>

          <button
            onClick={handleAddToCart}
            className="text-primary-default shrink-0"
          >
            + Add
          </button>
        </div>
      </div>

      <label htmlFor="add-to-cart-modal" className="hidden" ref={addToCardRef}>
        + Add
      </label>
    </div>
  );
}
